import { useTranslation } from 'react-i18next'
import { ListDrivers } from '~/features/common/Drivers/ListDrivers'
import { Container, PageContainer } from '~/shared/ui/Layout'

function ListDriversPage() {
  const { t } = useTranslation()
  return (
    <PageContainer title={t('drivers')}>
      <Container>
        <ListDrivers />
      </Container>
    </PageContainer>
  )
}

export default ListDriversPage
